@if (!nestedList) {
  <rt-placeholder-dropdown-typeahead
    [placeholders]="data"
    (select)="select($event)"
    (close)="close()"
  />
}
@if (nestedList) {
  <rt-placeholder-category-select-dropdown
    [header]="'app.email_templates.placeholder_categories_header' | translate"
    [placeholders]="data"
    (select)="select($event)"
  />
}
